export default "__VITE_ASSET__CrsehJcA__"